export const parametersColumns = ['name'];
export const industries = ['industryNumber', 'industryName', 'addressLine1', 'classification'];
